// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"fc85de2e","54":"0e9a6bfc","102":"fb194ec9","182":"07ece654","257":"1e8d764b","387":"92d41436","418":"3f0793a4","425":"9eb2ae0d","469":"718eff6c","496":"c53690f0","523":"772ff958","592":"a827c942","635":"544a4b06","915":"5dbcca1b"}[chunkId] + ".js";
};